<mat-toolbar
  class="toolbar"
  [class.impersonating]="loggedInUserIsImpersonating()"
  [class.has-alert-banner]="isAlertBannerPresent()"
  role="banner"
>
  @if (!suppressNavMenu()) {
    <button
      class="sidenav-button has-icon"
      matButton
      data-testid="main-nav-button"
      [attr.data-intercom-target]="intercomLabels.NAV_MENU"
      [attr.aria-expanded]="isSideNavOpen()"
      (click)="sideNavClicked()"
    >
      <img [src]="logoPath()" class="header-logo" alt="" />
      <span class="sidenav-label mat-title-small">Menu</span>
      <emperor-icon
        class="sidenav-icon"
        name="bp_chevron_down"
        strokeWeight="bold"
        [class.menu-open]="isSideNavOpen()"
      ></emperor-icon>
    </button>
  } @else {
    <img [src]="logoPath()" class="header-logo loading" alt="" />
  }

  <div class="left-menu-content">
    @if (loggedInUserIsImpersonating()) {
      <div class="impersonating-user" data-testid="impersonating">
        Impersonating {{ nameOfUserBeingImpersonated() }}
      </div>
    }
  </div>
  <div class="center-menu-content">
    @if (loggedInUserIsImpersonating()) {
      <emperor-link-button
        [href]="externalUrls.jiraCreateBugPage"
        target="_blank"
      >
        <span class="link-button-text">Create Bug</span>
      </emperor-link-button>
      @if (isFormLoaded()) {
        <emperor-link-button
          [uiButtonType]="uiButtonType.Raised"
          [href]="formVisualizerUrl()"
          target="_blank"
        >
          <span class="link-button-text">View in Partner Engine</span>
        </emperor-link-button>
      }
    }
    @if (isExchangeTenantType()) {
      <div class="exchange-type-promo">
        <span class="bold mat-body-large">Read only</span>To get the full
        Terminal experience schedule a demo today
      </div>
    }
  </div>
  <div class="right-menu-content">
    <app-profile-menu class="profile-menu-container"></app-profile-menu>
    @if (intercomEnabled()) {
      <address class="intercom-container">
        <button
          id="intercom-launcher"
          matButton
          emperorTooltip="Need help?"
          tooltipPlacement="bottom"
          aria-label="Chat for help"
          (click)="intercomActive ? onHideIntercom() : onShowIntercom()"
          [ngClass]="{ active: intercomActive }"
          class="has-icon"
        >
          <emperor-icon
            name="bp_chat_bubble_question"
            strokeWeight="bold"
          ></emperor-icon>
        </button>
      </address>
    }
  </div>
</mat-toolbar>
